import React, { useEffect, useState, useLayoutEffect } from "react";
import { formatCurrency } from "@/utils/formatCurrency";
import { roundPercentage } from "@/lib/utils";
import { useSyncronyGenerateTokenQuery } from "@/redux/apiSlices/synchronyApi";

const LearnHow = ({
  pageType = "PDP",
  displayPrice = 999.99,
  cartPrice,
  savingAmount,
  savingPercentage,
  crossedPrice,
}) => {
  const partnerId = "PI10000828";
  const price = displayPrice;
  const priceFormatted = price.toFixed(2);
  
  const [transactionToken, setTransactionToken] = useState(null);

  const { data: synchronyData, isSuccess: isTokenSuccess } =
    useSyncronyGenerateTokenQuery();

  useEffect(() => {
    if (isTokenSuccess && synchronyData?.data?.transactionToken) {
      setTransactionToken(synchronyData.data.transactionToken);
    }
  }, [isTokenSuccess, synchronyData, pageType]);

  // Load UniFi widget config and script
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined")
      return;

    if (!document.getElementById("syfConfigScript")) {
      const configScript = document.createElement("script");
      configScript.id = "syfConfigScript";
      configScript.innerHTML = `
         var syfWidgetObject = {
           syfPartnerId: "${partnerId}",
           flowType: "PDP",
           initialAmount: "${priceFormatted}"
         };
       `;
      document.head.appendChild(configScript);
    }

    if (!document.getElementById("syfMPPScript")) {
      const script = document.createElement("script");
      script.id = "syfMPPScript";
      script.src = "https://spdpone.syfpos.com/mpp/UniFi.js";
      script.async = true;
      script.onload = () => console.log("✅ UniFi.js loaded");
      script.onerror = () => console.error("❌ Failed to load UniFi.js");
      document.head.appendChild(script);
    }
  }, [partnerId, pageType, priceFormatted]);

  return (
    <>
      <div className="flex mb-4 pb-3 pt-2 items-start gap-3 z-[1] bg-white lg:pt-[17px] lg:px-[17px] lg:rounded-t-[12px] lg:mb-0">
        <div>
          <h3
            id="product-content"
            className="text-[37px] font-semibold text-black2 leading-[44px] lg:text-[32px]"
          >
            {formatCurrency(displayPrice)}
          </h3>
          {cartPrice && (
            <p className="text-gray2 text-[11px] font-medium leading-[16px] mr-1">
              *See final price in cart
            </p>
          )}
        </div>
          
        {(savingAmount || crossedPrice) && (
          <div className="pt-[3px]">
            {savingAmount && (
              <h5 className="text-red2 text-[14px] leading-[20px]">
                Save {formatCurrency(savingAmount)}{" "}
                {savingPercentage ? roundPercentage(savingPercentage) : ""}
              </h5>
            )}
            {crossedPrice && (
              <p className="text-[14px] line-through leading-[20px] font-medium">
                {formatCurrency(crossedPrice)}
              </p>
            )}
          </div>
        )}
      </div>

      <div className="sync-price" style={{ margin: "1rem 0" }} />
    </>
  );
};

export default LearnHow;
